module.exports = __webpack_public_path__ + "img/1.9f5912ec.jpg";